import {
  CustomListType,
  DeleteNotice,
  DeleteNoticeImage,
  NoticePatchParams,
} from "./../types/types";
import {
  CustomAxiosType,
  Notice,
  NoticeDetail,
  CustomAxiosSingleType,
  NoticePostParams,
} from "../types/types";
import { client } from "./client";

const b6t = `NB6T`;

interface GetNoticeParams {
  part: number;
  page: number;
  isAdmin?: boolean;
  area: string;
  newCheck?: number | null;
  limit?: number;
}

export interface GetNoticeDetailParams {
  idx: number;
  isAdmin: boolean;
}

// 공지 사항 조회
export const getNotice = async ({
  part,
  page,
  // isAdmin,
  area,
  newCheck,
  limit = 12,
}: GetNoticeParams) => {
  const response = await client.post<
    CustomAxiosType<CustomListType<Notice[]>>
  >(`/api/notice` + b6t + `/get`, {
    part,
    page,
    area,
    newCheck,
    limit,
  });

  return response.data.result;
};

// 공지 사항 상세 조회
export const getNoticeDetail = async ({
  idx,
  isAdmin,
}: GetNoticeDetailParams) => {
  const response = await client.post<CustomAxiosType<NoticeDetail>>(
    `/api/notice` + b6t + `/detail`,
    {
      idx,
      auth_notice: isAdmin,
    }
  );
  return response.data.result;
};

// 공지 사항 등록
export const postNotice = async ({
  contents,
  part,
  title,
  tag = "",
  writer_idx,
  area,
}: NoticePostParams) => {
  // if (contents.length > 2000) console.log(contents.length);
  const response = await client.post<CustomAxiosSingleType>(
    `/api/notice` + b6t,
    {
      contents,
      part,
      title,
      tag,
      writer_idx,
      area,
    }
  );
  return response.data;
};

// 공지 사항 삭제
export const deleteNotice = async ({ idx }: DeleteNotice) => {
  const response = await client.post<CustomAxiosType<{}>>(
    `/api/notice` + b6t + `/delete`,
    {
      idx,
    }
  );
  return response.data;
};

// 공지 사항 수정
export const putNotice = async ({
  contents,
  part,
  title,
  idx,
}: NoticePatchParams) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/notice` + b6t + `/patch`,
    {
      contents,
      part,
      title,
      idx,
    }
  );
  return response.data;
};

// 공지 사항 확인 체크
export const putReadingCheck = async ({ idx }: DeleteNotice) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/notice` + b6t + `/readingCheck/patch`,
    {
      idx,
    }
  );
  return response.data;
};

// 공지 사항 이미지 등록
export const postNoticeImage = async (file: any) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/notice` + b6t + `/image`,
    file
  );
  return response.data;
};

// 공지 이미지 삭제
export const deleteNoticeImage = async ({
  fileName,
}: DeleteNoticeImage) => {
  const response = await client.post(
    `/api/notice` + b6t + `/imgDel/delete`,
    {
      fileName,
    }
  );
  return response.data;
};
